import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'cboard.components.PinDialog.title',
    defaultMessage: 'Enter PIN'
  },
  description: {
    id: 'cboard.components.PinDialog.description',
    defaultMessage: 'Enter your 4-digit PIN to unlock'
  },
  incorrectPin: {
    id: 'cboard.components.PinDialog.incorrectPin',
    defaultMessage: 'Incorrect PIN. Please try again.'
  },
  cancel: {
    id: 'cboard.components.PinDialog.cancel',
    defaultMessage: 'Cancel'
  },
  unlock: {
    id: 'cboard.components.PinDialog.unlock',
    defaultMessage: 'Unlock'
  },
  togglePinVisibility: {
    id: 'cboard.components.PinDialog.togglePinVisibility',
    defaultMessage: 'Toggle PIN visibility'
  }
});
